import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CardLinkingOfferLocations } from './models/card-link-offer-location.model';

export interface CardLinkOfferLocationsState extends EntityState<CardLinkingOfferLocations> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'card-link-offer-locations', idKey: 'OfferId' })
export class CardLinkOfferLocationsStore extends EntityStore<CardLinkOfferLocationsState> {

  constructor() {
    super();
  }

}
